// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"513":"f389735a","703":"35b8c5b1","787":"4d4beb86"}[chunkId] + ".chunk.js";
};